export const PATH_ROUTES = {
	PATH_HOME: "/",
	PATH_CONTACT_US: "/contact-us",
	PATH_AIRCRAFT_TYPES: "/aircraft-types",
	// user profile
	PATH_ACCOUNT_DASHBOARD: "/account/dashboard",
	PATH_ACCOUNT_MY_PROFILE: "/account/my-profile",
	PATH_ACCOUNT_JET_ONE_SUITES: "/account/jet-one-suites",
	PATH_ACCOUNT_CHARTER: "/account/charter",
	PATH_ACCOUNT_AIR_FREIGHT: "/account/air-freight",
	PATH_ACCOUNT_SETTINGS: "/account/settings",
	PATH_JOURNEY: "/journey",
	PATH_SERVICE_AIR_FREIGHT: "/services/air-freight",
	PATH_SERVICE_JET_ONE_SUITES: "/services/jet-one-suites",
	PATH_SERVICE_PRIVATE_JET_TRAVEL: "/services/private-jet-travel",
	PATH_FAQs: "/faqs",
	PATH_TERM_CONDITIONS: "/term-conditions",
	PATH_PRIVACY_POLICY: "/privacy-policy",
	PATH_COOKIE_POLICY: "/cookie-policy",
	PATH_TRUSTED_PARTNERS: "/trusted-partners",
};
